class CartDrawer extends HTMLElement {
	constructor() {
		super();

		this.sectionHeader = document.querySelector(".shopify-section-header");
		this.header = document.querySelector(".header-wrapper");
		this.headerOverlay = document.querySelector(".header--has-overlay");

		if (this.header) this.header.preventHide = false;

		this.addEventListener(
			"keyup",
			(evt) => evt.code === "Escape" && this.close()
		);
		this.querySelector("#CartDrawer-Overlay").addEventListener(
			"click",
			this.close.bind(this)
		);
		this.setHeaderCartIconAccessibility();

		const headerAccount = document.querySelector(".header__account");
		if (headerAccount) {
			headerAccount.addEventListener("click", () => {
				if (this.classList.contains("active")) {
					this.close();
				}
			});
		}

		const localization = document.querySelectorAll(".header__localization");
		localization.forEach((localization) => {
			localization.addEventListener("click", () => {
				if (
					localization.querySelector("button[aria-expanded=true]") &&
					this.classList.contains("active")
				) {
					this.close();
				}
			});
		});
	}

	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelector("#cart-icon-bubble");
		cartLink.setAttribute("role", "button");
		cartLink.setAttribute("aria-haspopup", "dialog");
		cartLink.addEventListener("click", (event) => {
			event.preventDefault();
			if (!this.classList.contains("active")) this.open(cartLink);
			else this.close();
		});
		cartLink.addEventListener("keydown", (event) => {
			if (event.code.toUpperCase() === "SPACE") {
				event.preventDefault();
				if (!this.classList.contains("active")) this.open(cartLink);
				else this.close();
			}
		});
	}

	open(triggeredBy) {
		if (this.header) this.header.preventHide = true;
		if (triggeredBy) this.setActiveElement(triggeredBy);
		const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
		const cartDrawerNoteText = document.getElementById("CartDrawer-Note");
		const CartDrawerNoteEdit = document.getElementById("CartDrawer-Note-Edit");

		if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
			this.setSummaryAccessibility(cartDrawerNote);
		setTimeout(() => {
			this.classList.add("animate", "active");

			const closeButton = document.querySelector(".cart__note-close-button");
			if (closeButton) {
				closeButton.addEventListener("click", function () {
					if (CartDrawerNoteEdit) {
						if (cartDrawerNoteText.value.trim() !== "") {
							CartDrawerNoteEdit.classList.add("show");
						} else {
							CartDrawerNoteEdit.classList.remove("show");
						}
					}
					document.getElementById("Details-CartDrawer").removeAttribute("open");
				});
			}
		});

		this.addEventListener(
			"transitionend",
			() => {
				const containerToTrapFocusOn = this.classList.contains("is-empty")
					? this.querySelector(".drawer__inner-empty")
					: document.getElementById("CartDrawer");
				const focusElement =
					this.querySelector(".drawer__inner") ||
					this.querySelector(".drawer__close");
				trapFocus(containerToTrapFocusOn, focusElement);
			},
			{ once: true }
		);

		document.body.classList.add("overflow-hidden-drawer");
		this.headerOverlay?.classList.remove("color-background-overlay");
		this.headerOverlay?.classList.add("color-background-overlay-hidden");
		this.sectionHeader.classList.remove("shopify-section-header-hidden");
	}

	close() {
		this.classList.remove("active");
		removeTrapFocus(this.activeElement);
		document.body.classList.remove("overflow-hidden-drawer");
		if (this.header) this.header.preventHide = false;

		this.headerOverlay?.classList.add("color-background-overlay");
		this.headerOverlay?.classList.remove("color-background-overlay-hidden");
	}

	setSummaryAccessibility(cartDrawerNote) {
		cartDrawerNote.setAttribute("role", "button");
		cartDrawerNote.setAttribute("aria-expanded", "false");

		if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
			cartDrawerNote.setAttribute(
				"aria-controls",
				cartDrawerNote.nextElementSibling.id
			);
		}

		cartDrawerNote.addEventListener("click", (event) => {
			event.currentTarget.setAttribute(
				"aria-expanded",
				!event.currentTarget.closest("details").hasAttribute("open")
			);
		});

		cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
	}

	renderContents(parsedState) {
		this.querySelector(".drawer__inner").classList.contains("is-empty") &&
			this.querySelector(".drawer__inner").classList.remove("is-empty");
		this.productId = parsedState.id;
		// NegoStore (perf 20.10.2026): X-1, latimea veche a barei de livrare pentru
		// cart-drawer-items nou (constructorul lui ruleaza in timpul innerHTML).
		CartItems.shippingFrom = this.shippingWidth();
		this.getSectionsToRender().forEach((section) => {
			const sectionElement = section.selector
				? document.querySelector(section.selector)
				: document.getElementById(section.id);
			sectionElement.innerHTML = this.getSectionInnerHTML(
				parsedState.sections[section.id],
				section.selector
			);
		});
		CartItems.shippingFrom = null;
		// NegoStore (perf 20.10.2026): o stare noua a cosului a fost randata; un
		// refresh() pornit inainte isi cere din nou datele (vezi refresh).
		CartItems.renderMark++;

		setTimeout(() => {
			this.querySelector("#CartDrawer-Overlay").addEventListener(
				"click",
				this.close.bind(this)
			);
			this.open();
		});
	}

	// NegoStore (perf 20.10.2026): C-1/APP-1. Reimprospateaza sertarul si bulina
	// cand cosul a fost schimbat din afara temei (FeeBee publica 'cart-update'
	// dupa ce adauga sau scoate linia 'Garantie SGR'). Inainte, CartDrawerItems
	// mostenea onCartUpdate de la pagina /cart si scria in sertar markup-ul
	// paginii /cart ('Cosul tau este gol', produsul si cardul de locker disparute).
	// Acum: o singura cerere ?sections=cart-drawer,cart-icon-bubble (aceleasi
	// sectiuni si selectori ca renderContents), fara open()/close(): un sertar
	// deschis ramane deschis, unul inchis ramane inchis. Cardul xConnector
	// ([data-xc-slot]) se reaseaza singur, prin MutationObserver-ul lor pe body,
	// ca dupa renderContents.
	refresh() {
		const seq = (this.refreshSeq = (this.refreshSeq || 0) + 1);
		const mark = CartItems.renderMark;
		const ids = this.getSectionsToRender().map((section) => section.id);

		// NegoStore (perf 20.10.2026, verify): FARA antetul Accept: application/json.
		// Cu el, Shopify raspunde la /cart?sections= cu cosul JSON (ca /cart.js), nu
		// cu sectiunile, iar reimprospatarea nu randa nimic (rand SGR orfan ramas).
		return fetch(`${routes.cart_url}?sections=${ids.join(",")}`)
			.then((response) => {
				if (!response.ok) throw new Error(`sections ${response.status}`);
				return response.json();
			})
			.then((sections) => {
				// Un refresh mai nou e deja pe drum.
				if (seq !== this.refreshSeq) return;
				// Intre timp sertarul a fost randat dintr-o adaugare sau modificare a
				// temei: raspunsul asta poate fi mai vechi, deci il cerem din nou.
				if (mark !== CartItems.renderMark) return this.refresh();
				this.renderRefresh(sections);
			})
			.catch((error) => {
				console.error(error);
			});
	}

	renderRefresh(sections) {
		const drawerHTML = sections ? sections["cart-drawer"] : null;
		if (typeof drawerHTML !== "string") return;
		const drawerDoc = new DOMParser().parseFromString(drawerHTML, "text/html");
		const sourceInner = drawerDoc.querySelector("#CartDrawer");
		const target = document.getElementById("CartDrawer");
		if (!sourceInner || !target) return;

		// Ce tine de cumparator si nu vine de pe server: focusul, nota deschisa si
		// textul ei inca nesalvat (cart-note salveaza dupa 300 ms), pozitia de scroll.
		const wasActive = this.classList.contains("active");
		const focused = document.activeElement;
		const hadFocus = !!(focused && focused !== document.body && this.contains(focused));
		const focusId = hadFocus ? focused.id || null : null;
		const details = document.getElementById("Details-CartDrawer");
		const noteOpen = !!(details && details.hasAttribute("open"));
		const note = document.getElementById("CartDrawer-Note");
		const noteValue = note ? note.value : null;
		const items = this.querySelector("cart-drawer-items");
		const scrollTop = wasActive && items ? items.scrollTop : 0;

		CartItems.shippingFrom = this.shippingWidth();
		target.innerHTML = sourceInner.innerHTML;
		CartItems.shippingFrom = null;
		CartItems.renderMark++;

		const sourceDrawer = drawerDoc.querySelector("cart-drawer");
		this.classList.toggle(
			"is-empty",
			sourceDrawer ? sourceDrawer.classList.contains("is-empty") : false
		);

		const bubble = document.getElementById("cart-icon-bubble");
		const bubbleHTML = sections["cart-icon-bubble"];
		if (bubble && typeof bubbleHTML === "string") {
			const source = this.getSectionDOM(bubbleHTML);
			if (source) bubble.innerHTML = source.innerHTML;
		}

		const overlay = this.querySelector("#CartDrawer-Overlay");
		if (overlay) overlay.addEventListener("click", this.close.bind(this));

		const newNote = document.getElementById("CartDrawer-Note");
		if (newNote && noteValue !== null && newNote.value !== noteValue) {
			newNote.value = noteValue;
		}
		const newDetails = document.getElementById("Details-CartDrawer");
		if (newDetails && noteOpen) newDetails.setAttribute("open", "");
		const noteClose = this.querySelector(".cart__note-close-button");
		if (noteClose) {
			noteClose.addEventListener("click", () => {
				const edit = document.getElementById("CartDrawer-Note-Edit");
				const text = document.getElementById("CartDrawer-Note");
				if (edit && text) edit.classList.toggle("show", text.value.trim() !== "");
				const openDetails = document.getElementById("Details-CartDrawer");
				if (openDetails) openDetails.removeAttribute("open");
			});
		}

		if (!wasActive) return;
		const summary = this.querySelector('[id^="Details-"] summary');
		if (summary && !summary.hasAttribute("role"))
			this.setSummaryAccessibility(summary);
		const newItems = this.querySelector("cart-drawer-items");
		if (scrollTop > 0 && newItems) newItems.scrollTop = scrollTop;
		if (hadFocus) {
			const focusTarget =
				(focusId && document.getElementById(focusId)) ||
				this.querySelector(".drawer__inner") ||
				this.querySelector(".drawer__close");
			if (focusTarget)
				trapFocus(document.getElementById("CartDrawer"), focusTarget);
		}
	}

	// NegoStore (perf 20.10.2026): X-1, latimea curenta a barei de livrare din
	// sertar, din style.width (procent), fara citire de layout.
	shippingWidth() {
		const bar = this.querySelector(".cart-shipping__progress-current");
		return bar && bar.style.width ? bar.style.width : null;
	}

	getSectionInnerHTML(html, selector = ".shopify-section") {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector).innerHTML;
	}

	getSectionsToRender() {
		return [
			{
				id: "cart-drawer",
				selector: "#CartDrawer",
			},
			{
				id: "cart-icon-bubble",
			},
		];
	}

	getSectionDOM(html, selector = ".shopify-section") {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector);
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
	// NegoStore (perf 20.10.2026): C-1/APP-1. Sertarul nu mai foloseste
	// onCartUpdate-ul paginii /cart (scria markup-ul /cart in sertar).
	// - sursa 'product-form': nimic, renderContents() randeaza sertarul din
	//   raspunsul /cart/add imediat dupa publish (inainte se facea o cerere
	//   main-cart-items in plus, al carei rezultat era aruncat);
	// - orice alta sursa (FeeBee 'quick-add' etc.): CartDrawer.refresh().
	// Sursa 'cart-items' e oprita deja in CartItems.connectedCallback.
	onCartUpdate(event) {
		if (event && event.source === "product-form") return;
		const drawer =
			this.closest("cart-drawer") || document.querySelector("cart-drawer");
		if (drawer && typeof drawer.refresh === "function") drawer.refresh();
	}

	getSectionsToRender() {
		return [
			{
				id: "CartDrawer",
				section: "cart-drawer",
				selector: ".drawer__inner",
			},
			{
				id: "cart-icon-bubble",
				section: "cart-icon-bubble",
				selector: ".shopify-section",
			},
		];
	}
}

customElements.define("cart-drawer-items", CartDrawerItems);
